/**
 * Tentatively decied to send audit log events for for confluence page
 * and Jira issue description.
 * Structure of AuditLogSettings can be changed once API spec if fianlised.
 */

export var auditLogEvents = ['ai-generated-content-inserted', 'aup-violation'];